import { useCallback } from 'react';
import { manageAutoFunding } from '../../providers-list/api';

const useSaveSellerLabelProviderAutoFunding = (sellerLabelProviderId) => {
  return useCallback(
    (config) => {
      return manageAutoFunding(sellerLabelProviderId, config);
    },
    [sellerLabelProviderId],
  );
};

export default useSaveSellerLabelProviderAutoFunding;
